export default {
  "path": "/demo/introduce",
  "meta": {
    "name": "demo-开发简介",
    "title": "开发简介",
    "isComponentDoc": true,
    "category": "Introduce"
  }
};